import { ThunkDispatch } from "core-integration/src/store";
import { getElementStatsByIdentifier } from "core-integration/src/store/element-stats/reducers";
import { IElementStat } from "core-integration/src/store/element-stats/types";
import { getElementsById } from "core-integration/src/store/elements/reducers";
import { showElementSummary } from "core-integration/src/store/elements/thunks";
import {
  IFixtureStat,
  IFixtureStats,
} from "core-integration/src/store/fixtures/types";
import { useDispatch, useSelector } from "react-redux";
import { UnstyledRACButton } from "../../../buttons/UnstyledRACButton";
import {
  itemStyle,
  statContent,
  statHeader,
  statWrapper,
} from "../fixtureStats.css";

interface StateProps {
  stat: IFixtureStats;
}

const StatItems = ({ stats }: { stats: IFixtureStat[] }) => {
  const dispatch = useDispatch<ThunkDispatch>();
  const elementsById = useSelector(getElementsById);

  const handleOpenPlayerProfile = (elementId: number) =>
    dispatch(showElementSummary(elementId));

  return (
    <ul className={itemStyle}>
      {stats
        .filter((fs) => elementsById[fs.element])
        .map((fs) => (
          <li key={fs.element}>
            <UnstyledRACButton
              onPress={() => handleOpenPlayerProfile(fs.element)}
            >
              {elementsById[fs.element].web_name}
            </UnstyledRACButton>{" "}
            ({fs.value})
          </li>
        ))}
    </ul>
  );
};

const Stat = ({ stat }: StateProps) => {
  const statsByIdentifier: Record<string, IElementStat> = useSelector(
    getElementStatsByIdentifier,
  );

  return (
    <li key={stat.identifier} className={statWrapper}>
      <h3 className={statHeader}>{statsByIdentifier[stat.identifier].label}</h3>
      <div className={statContent}>
        <StatItems stats={stat.h} />
        <StatItems stats={stat.a} />
      </div>
    </li>
  );
};

export default Stat;
